import { Observer } from './Observer';

export class BehaviorSubject {
  constructor(initialState) {
    this.value = initialState;
    this.oldValue = null;
    this.observers = [];
  }

  subscribe(callback, initialCall = false) {
    if (initialCall) {
      callback(this.value, { prev: null });
    }
    const observer = new Observer(callback);
    this.observers.push(observer);
    return {
      observer,
      unsubscribe: () => this.unsubscribe(observer.id),
    };
  }

  unsubscribe(observerId) {
    this.observers = this.observers.filter(({ id }) => id !== observerId);
  }

  next(value) {
    this.oldValue = this.value;
    this.value = value;
    this._notify();
  }

  getValue() {
    return this.value;
  }

  _notify() {
    this.observers.forEach(({ method }) => {
      method(this.value, { prev: this.oldValue });
    });
  }
}
